export const SUBSCRIPTION = "SUBSCRIPTION";
export const BOND_LINKED_ACCOUNT = "BOND_LINKED_ACCOUNT";
export const PERSONA_DATA = "PERSONA_DATA";
export const PERSONA_INQUIRY_ID = "PERSONA_INQUIRY_ID";
export const BOND_BUSINESS_ID = "BOND_BUSINESS_ID";
export const LOGO_UPDATE = "LOGO_UPDATE";
